import { render, staticRenderFns } from "./ReportStrangerDetail.vue?vue&type=template&id=ef53ebd4"
import script from "./ReportStrangerDetail.vue?vue&type=script&lang=js"
export * from "./ReportStrangerDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportStrangerDetail.vue?vue&type=style&index=0&id=ef53ebd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports